import React from 'react';
import { Table } from 'reactstrap';
import SortableTh from '@components/SortableTh/SortableTh';

export default props => {
  return (
    <Table className={'mt-3'} hover={true}>
      <thead>
        <tr>
          <SortableTh {...props} label={'Name'} field={'name'} />
          <SortableTh {...props} label={'NAIC #'} field={'naic_number'} />
        </tr>
      </thead>
      <tbody>
        {props.entities.map(item => {
          return (
            <tr
              className={'pointer'}
              key={'carriers-' + item.id}
              onClick={() => props.onEntityClick(item.id)}
            >
              <td>{item.name}</td>
              <td>{item.naic_number}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};
